import { useLocation } from "react-router";
import { Menu } from "antd";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled";

const StyledMenu = styled(Menu)`
  background-color: rgba(0, 0, 0, 0);
  border-bottom: none !important;
`;

const StyledMenuItem = styled(Menu.Item)`
  a {
    color: #ffffff !important;
  }
`;

function MenuItems() {
  const { pathname } = useLocation();

  return (
    <StyledMenu
      theme="light"
      mode="horizontal"
      style={{
        display: "flex",
        fontSize: "17px",
        fontWeight: "500",
        width: "100%",
        justifyContent: "center",
        color: "#000",
        background: "none",
      }}
      defaultSelectedKeys={[pathname]}
    >
      <StyledMenuItem key="/">
        <NavLink to="/">Home</NavLink>
      </StyledMenuItem>

      <StyledMenuItem key="/dexscreener">
        <NavLink to="/dexscreener">Dexscreener</NavLink>
      </StyledMenuItem>

      <StyledMenuItem key="/analytics">
        <NavLink to="/analytics">Advanced Analytics</NavLink>
      </StyledMenuItem>

      <StyledMenuItem key="/bridging">
        <NavLink to="/bridging">Good Bridging</NavLink>
      </StyledMenuItem>

      <StyledMenuItem key="/community-projects">
        <NavLink to="/community-projects">Community Projects</NavLink>
      </StyledMenuItem>
    </StyledMenu>
  );
}

export default MenuItems;
